import { SearchOutlined, WarningOutlined } from '@ant-design/icons';
import { Row, Col, Button } from 'antd';
import { Formik } from 'formik';
import { Form, Radio, Input, Select, SubmitButton } from 'formik-antd';
import { getCountFacilityCode, updateCountFacilityCode } from 'pages/MedicalInstitutionRegister/thunk';
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { RootState } from 'store';
// @ts-ignore
import zipcodeJa from 'zipcode-ja';
import { HeaderTitle, ModalWarningLeavePage } from 'components';
import { t_medical_institution } from 'types';
import { PaymentMethodSearch } from 'utils';
import { yup } from 'utils';
import { getWorkspace } from '../../LoginPage/thunk';
import { updateMedicalDetail } from '../MedicalInstitutionDetail/slice';
import Wrap from './styles';
import { getFieldMedical, updateMedical } from './thunk';

const { TextArea } = Input;

const MedicalInstitutionEdit: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data } = useSelector((state: RootState) => state.medicalDetail);
  const { currentApplicationId } = useSelector((state: RootState) => state.workSpaces);
  const { fieldsMedical } = useSelector((state: RootState) => state.medicalDetail);

  const [zipcodeLeft, setZipcodeLeft] = useState<string>(data?.facility_zip?.slice(0, 3) || '');
  const [zipcodeRight, setZipcodeRight] = useState<string>(data?.facility_zip?.slice(4) || '');
  const [address, setAddress] = useState<string>(data?.facility_address1 || '');
  const [paymentMethod, setPaymentMethod] = useState<string>(data?.payment_method || '');

  useEffect(() => {
    dispatch(getWorkspace());
  }, [dispatch]);

  useEffect(() => {
    currentApplicationId &&
      dispatch(getFieldMedical({ appId: currentApplicationId, dataStoreId: 't_medical_institution' }));
  }, [dispatch, currentApplicationId]);

  const optionPayment = useMemo(() => {
    return (
      (fieldsMedical.length > 0 &&
        fieldsMedical.find(([_key, value]: [string, any]) => value.display_id === 'payment_method')[1].options) ||
      []
    );
  }, [fieldsMedical]);

  const optionBilling = useMemo(() => {
    return (
      (fieldsMedical.length > 0 &&
        fieldsMedical.find(([_key, value]: [string, any]) => value.display_id === 'billable_month')[1].options) ||
      []
    );
  }, [fieldsMedical]);

  const handleSubmit = async (values: t_medical_institution) => {
    const newZipcode = zipcodeLeft && zipcodeRight ? `${zipcodeLeft}-${zipcodeRight}` : undefined;
    const payment = optionPayment.find((f: any) => f.value === paymentMethod);
    const bill = optionBilling.find((f: any) => f.value === values.billable_month);
    let newFcode = data?.facility_code;
    let items: any = null;
    if (paymentMethod && paymentMethod !== data?.payment_method) {
      items = await dispatch(getCountFacilityCode(PaymentMethodSearch(paymentMethod)));
      const codeNumber = (+items.payload[0].count + 1).toString();
      newFcode = items.payload[0].prefix + '-';
      newFcode += codeNumber.length === 1 ? '00' + codeNumber : codeNumber.length === 2 ? '0' + codeNumber : codeNumber;
    }
    const dataUpdate: t_medical_institution = {
      i_id: data?.i_id,
      d_id: data?.d_id,
      facility_code: newFcode,
      facility_name: values.facility_name,
      facility_address2: values.facility_address2,
      facility_tel: values.facility_tel,
      facility_name_for_invoice: values.facility_name_for_invoice?.trim(),
      facility_address_for_invoice: values.facility_address_for_invoice?.trim(),
      cpap_unit_price: values.cpap_unit_price ? +values.cpap_unit_price : 0,
      cpap_unit_sp_price: values.cpap_unit_sp_price ? +values.cpap_unit_sp_price : 0,
      psg_unit_price: values.psg_unit_price ? +values.psg_unit_price : 0,
      simplicity_unit_price: values.simplicity_unit_price ? +values.simplicity_unit_price : 0,
      facility_zip: newZipcode,
      facility_address1: address,
      billable_month: bill && bill.option_id,
      payment_method: payment && payment.option_id,
      account_name: values.account_name,
      remark_for_remittance: values.remark_for_remittance,
      in_charge_of_sales: values.in_charge_of_sales,
    };
    const resultAction = await dispatch(updateMedical(dataUpdate));
    if ('payload' in resultAction) {
      dispatch(
        updateMedicalDetail({ ...dataUpdate, billable_month: values.billable_month, payment_method: paymentMethod }),
      );
      items && dispatch(updateCountFacilityCode({ ...items.payload[0], count: parseInt(items.payload[0].count) + 1 }));
      history.push('/medical_institution/detail', { omitWarningLeavePage: true });
    }
  };

  const convertZipCodeToAddress = () => {
    const zipCode: string = `${zipcodeLeft}${zipcodeRight}`;
    const address = zipcodeJa[zipCode]?.address;
    const result = !address ? '' : address.join(' ');
    setAddress(result);
  };

  if (!data) {
    return <Redirect to="/medical_institution" />;
  }

  return (
    <Wrap>
      <HeaderTitle title="医療機関一覧・検索" icon={SearchOutlined} />
      <div className="detail-medical">
        <span className="extraLargeFont">医療機関詳細</span>
      </div>
      <div className="section">
        <span className="smallBoldFont ※">※</span>
        <span className="standardFont">は必須項目</span>
        <Formik
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          initialValues={data || initialValues}
          render={({ isValid }) => (
            <Form autoComplete={`${Math.random()}`}>
              <div className="input-form">
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">医療機関名</span>
                      <span className="※ standardFont">※</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="facility_name">
                      <Input name="facility_name" required size="large" autoComplete={`${Math.random()}`} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5} />
                  <Col span={15}>
                    <Row>
                      <label className="standardFont mb-7 bold">請求書出力用 改行位置設定</label>
                    </Row>
                    <Form.Item name="facility_name_for_invoice">
                      <TextArea name="facility_name_for_invoice" rows={4} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}></Col>
                  <Col span={15}>
                    <Row>
                      <label className="standardFont mb-7" htmlFor="post-office">
                        郵便番号
                      </label>
                    </Row>
                    <Input
                      name="zipcode-left"
                      value={zipcodeLeft}
                      style={{ width: '92px' }}
                      id="post-office"
                      onChange={(e) => setZipcodeLeft(e.target.value)}
                      placeholder="例：576"
                      maxLength={3}
                      size="large"
                      autoComplete={`${Math.random()}`}
                    />
                    <span> - </span>
                    <Input
                      name="zipcode-right"
                      value={zipcodeRight}
                      onChange={(e) => setZipcodeRight(e.target.value)}
                      maxLength={4}
                      style={{ width: '127px' }}
                      placeholder="例：0033"
                      size="large"
                      autoComplete={`${Math.random()}`}
                    />
                    <Button className="btn-search" onClick={convertZipCodeToAddress}>
                      住所検索
                    </Button>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align" style={{ marginTop: '15px' }}>
                  <Col span={5}>
                    <div>
                      <span className="standardBoldFont">所在地</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Row>
                      <label className="standardFont mb-7" htmlFor="location">
                        都道府県/市区町村/番地
                      </label>
                    </Row>
                    <Form.Item name="facility_address1">
                      <Input
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        name="facility_address1"
                        placeholder="例：大阪府 交野市 5-6-4"
                        size="large"
                        autoComplete={`${Math.random()}`}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}></Col>
                  <Col span={15}>
                    <Row>
                      <label className="standardFont mb-7" htmlFor="address">
                        マンション・ビル・建物
                      </label>
                    </Row>
                    <Form.Item name="facility_address2">
                      <Input
                        name="facility_address2"
                        placeholder="例：スリープビル101号"
                        size="large"
                        autoComplete={`${Math.random()}`}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5} />
                  <Col span={15}>
                    <Row>
                      <label className="standardFont mb-7 bold">
                        請求書出力用 改行位置設定 （都道府県/市区町村/番地 マンション・ビル・建物）
                      </label>
                    </Row>
                    <Form.Item name="facility_address_for_invoice">
                      <TextArea name="facility_address_for_invoice" rows={4} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">電話番号</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="facility_tel">
                      <Input
                        name="facility_tel"
                        id="facility_tel"
                        placeholder="例：072-819-5553"
                        size="large"
                        autoComplete={`${Math.random()}`}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align mt-28 mb-29">
                  <Col span={5}>
                    <div>
                      <span className="standardBoldFont">支払い方法</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Radio.Group
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      name="payment_method"
                    >
                      {optionPayment.map((data: any, i: number) => (
                        <Radio key={i} name="payment_method" value={data.value}>
                          {data.value}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">CPAP単価</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="cpap_unit_price">
                      <Input name="cpap_unit_price" className="pr" size="large" autoComplete={`${Math.random()}`} />
                    </Form.Item>
                    <svg
                      style={{ position: 'absolute', top: '8px', left: '5px', width: '10px', height: '24px' }}
                      width="10"
                      height="11"
                      viewBox="0 0 10 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.474 10.916C5.39 10.412 5.362 10.048 5.362 9.348V7.976H7.42C8.022 7.976 8.4 8.004 8.876 8.088V7.038C8.4 7.122 8.036 7.15 7.42 7.15H5.362V6.492L5.922 5.652H7.42C8.036 5.652 8.414 5.68 8.89 5.764V4.714C8.414 4.798 8.05 4.826 7.42 4.826H6.44L8.596 1.494C8.974 0.92 9.268 0.514 9.464 0.276H7.952C7.854 0.598 7.686 0.906 7.28 1.564L4.844 5.512L2.394 1.564C1.946 0.863999 1.82 0.598 1.708 0.276H0.21C0.42 0.541999 0.644 0.863999 1.05 1.494L3.22 4.826H2.24C1.61 4.826 1.26 4.798 0.784 4.714V5.764C1.26 5.68 1.61 5.652 2.24 5.652H3.752L4.298 6.478V7.15H2.24C1.61 7.15 1.26 7.122 0.784 7.038V8.088C1.26 8.004 1.61 7.976 2.24 7.976H4.298V9.348C4.298 9.978 4.27 10.426 4.186 10.916H5.474Z"
                        fill="black"
                      />
                    </svg>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">CPAP単価 特別料金</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="cpap_unit_sp_price">
                      <Input name="cpap_unit_sp_price" className="pr" size="large" autoComplete={`${Math.random()}`} />
                    </Form.Item>
                    <svg
                      style={{ position: 'absolute', top: '8px', left: '5px', width: '10px', height: '24px' }}
                      width="10"
                      height="11"
                      viewBox="0 0 10 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.474 10.916C5.39 10.412 5.362 10.048 5.362 9.348V7.976H7.42C8.022 7.976 8.4 8.004 8.876 8.088V7.038C8.4 7.122 8.036 7.15 7.42 7.15H5.362V6.492L5.922 5.652H7.42C8.036 5.652 8.414 5.68 8.89 5.764V4.714C8.414 4.798 8.05 4.826 7.42 4.826H6.44L8.596 1.494C8.974 0.92 9.268 0.514 9.464 0.276H7.952C7.854 0.598 7.686 0.906 7.28 1.564L4.844 5.512L2.394 1.564C1.946 0.863999 1.82 0.598 1.708 0.276H0.21C0.42 0.541999 0.644 0.863999 1.05 1.494L3.22 4.826H2.24C1.61 4.826 1.26 4.798 0.784 4.714V5.764C1.26 5.68 1.61 5.652 2.24 5.652H3.752L4.298 6.478V7.15H2.24C1.61 7.15 1.26 7.122 0.784 7.038V8.088C1.26 8.004 1.61 7.976 2.24 7.976H4.298V9.348C4.298 9.978 4.27 10.426 4.186 10.916H5.474Z"
                        fill="black"
                      />
                    </svg>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">出張PSG検査単価</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="psg_unit_price">
                      <Input name="psg_unit_price" className="pr" size="large" autoComplete={`${Math.random()}`} />
                    </Form.Item>
                    <svg
                      style={{ position: 'absolute', top: '8px', left: '5px', width: '10px', height: '24px' }}
                      width="10"
                      height="11"
                      viewBox="0 0 10 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.474 10.916C5.39 10.412 5.362 10.048 5.362 9.348V7.976H7.42C8.022 7.976 8.4 8.004 8.876 8.088V7.038C8.4 7.122 8.036 7.15 7.42 7.15H5.362V6.492L5.922 5.652H7.42C8.036 5.652 8.414 5.68 8.89 5.764V4.714C8.414 4.798 8.05 4.826 7.42 4.826H6.44L8.596 1.494C8.974 0.92 9.268 0.514 9.464 0.276H7.952C7.854 0.598 7.686 0.906 7.28 1.564L4.844 5.512L2.394 1.564C1.946 0.863999 1.82 0.598 1.708 0.276H0.21C0.42 0.541999 0.644 0.863999 1.05 1.494L3.22 4.826H2.24C1.61 4.826 1.26 4.798 0.784 4.714V5.764C1.26 5.68 1.61 5.652 2.24 5.652H3.752L4.298 6.478V7.15H2.24C1.61 7.15 1.26 7.122 0.784 7.038V8.088C1.26 8.004 1.61 7.976 2.24 7.976H4.298V9.348C4.298 9.978 4.27 10.426 4.186 10.916H5.474Z"
                        fill="black"
                      />
                    </svg>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">簡易PSG検査単価</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="simplicity_unit_price">
                      <Input
                        name="simplicity_unit_price"
                        className="pr"
                        size="large"
                        autoComplete={`${Math.random()}`}
                      />
                    </Form.Item>
                    <svg
                      style={{ position: 'absolute', top: '8px', left: '5px', width: '10px', height: '24px' }}
                      width="10"
                      height="11"
                      viewBox="0 0 10 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.474 10.916C5.39 10.412 5.362 10.048 5.362 9.348V7.976H7.42C8.022 7.976 8.4 8.004 8.876 8.088V7.038C8.4 7.122 8.036 7.15 7.42 7.15H5.362V6.492L5.922 5.652H7.42C8.036 5.652 8.414 5.68 8.89 5.764V4.714C8.414 4.798 8.05 4.826 7.42 4.826H6.44L8.596 1.494C8.974 0.92 9.268 0.514 9.464 0.276H7.952C7.854 0.598 7.686 0.906 7.28 1.564L4.844 5.512L2.394 1.564C1.946 0.863999 1.82 0.598 1.708 0.276H0.21C0.42 0.541999 0.644 0.863999 1.05 1.494L3.22 4.826H2.24C1.61 4.826 1.26 4.798 0.784 4.714V5.764C1.26 5.68 1.61 5.652 2.24 5.652H3.752L4.298 6.478V7.15H2.24C1.61 7.15 1.26 7.122 0.784 7.038V8.088C1.26 8.004 1.61 7.976 2.24 7.976H4.298V9.348C4.298 9.978 4.27 10.426 4.186 10.916H5.474Z"
                        fill="black"
                      />
                    </svg>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">請求可能未受診月数</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="billable_month">
                      <Select name="billable_month" size="large" style={{ width: '100px' }}>
                        {listBill.map((data: string, i: number) => (
                          <Select.Option key={i} value={data}>
                            {data}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">入金名</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="account_name">
                      <Input name="account_name" size={'large'} autoComplete={`${Math.random()}`} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">入金リスト振込備考</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="remark_for_remittance">
                      <Input name="remark_for_remittance" size={'large'} autoComplete={`${Math.random()}`} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="pl-5 flex-align">
                  <Col span={5}>
                    <div className="title-input">
                      <span className="standardBoldFont">営業担当</span>
                    </div>
                  </Col>
                  <Col span={15}>
                    <Form.Item name="in_charge_of_sales">
                      <Input name="in_charge_of_sales" size={'large'} autoComplete={`${Math.random()}`} />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              {!isValid && (
                <div style={{ marginTop: '0.5rem' }} className="error">
                  <WarningOutlined />
                  <p>入力内容に不備がございます。エラーが表示されている項目をご確認ください。</p>
                </div>
              )}
              <div className="confirm-update-btn">
                <Button onClick={() => history.goBack()} className="btn-cancel-save">
                  キャンセル
                </Button>
                <SubmitButton className="btn-save">更新する</SubmitButton>
              </div>
            </Form>
          )}
        />
      </div>
      <ModalWarningLeavePage />
    </Wrap>
  );
};

const initialValues: t_medical_institution = {
  facility_name: '',
  facility_zip: '',
  facility_address1: '',
  facility_address2: '',
  facility_name_for_invoice: '',
  facility_address_for_invoice: '',
  facility_tel: '',
  cpap_unit_price: 0,
  cpap_unit_sp_price: 0,
  psg_unit_price: 0,
  simplicity_unit_price: 0,
  facility_code: '',
  payment_method: '',
  billable_month: '',
  account_name: '',
};

const validationSchema = yup.object().shape({
  facility_tel: yup.string().matches(/^(([0-9]{1,}(-){0,}){1,}([0-9]){1,})$/, '数字と記号のみ入力可能 -'),
  facility_name: yup.string().required('医療機関名を入力して下さい'),
  cpap_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  cpap_unit_sp_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  psg_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  simplicity_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
});

const listBill: string[] = ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export default MedicalInstitutionEdit;
